@if (block && !hidden) {
  <section class="banner-block" [class.normal-width]="block.widthMode === 'normal'" [class.pointer-events-none]="!block.link || !block.link.uri">
    <a class="image" [class.image-link]="block.link?.uri" [extendedRouterLink]="block.link?.uri" #imageWrapperEl>
      @if (block.backgroundVideo || block.backgroundVideoPhone) {
        <ng-container *ngIfMediaQuery="'(min-width: 640px)'; else mobileVideoTmp">
          @if (block.backgroundVideo) {
            <lib-video
              [src]="block.backgroundVideo | videoPresign | async"
              class="background-video position-cover"
              [hideControls]="true"
              [loop]="true"
              [autoplay]="true">
            </lib-video>
          }
        </ng-container>
      }
      @if (block.mediaImage || block.mediaImagePhone) {
        <ng-container *ngIfMediaQuery="'(min-width: 640px)'; else mobileImageTmp">
          @if (block.mediaImage && !block.backgroundVideo) {
            <img
              [cropImage]="block.mediaImage | preSignedUrl | async"
              [crop]="block?.mediaImage?.crop"
              [additionalOptions]="{width: 1920}"
              [attr.alt]="block.mediaImage.alt">
          }
        </ng-container>
      }
      <ng-template #mobileImageTmp>
        @if ((!block.backgroundVideoPhone && (block.mediaImagePhone || (!block.backgroundVideo && block.mediaImage))); as mobileImage) {
          <img
            [cropImage]="mobileImage | preSignedUrl | async"
            [crop]="mobileImage?.crop"
            [additionalOptions]="{width: 600}"
            [attr.alt]="mobileImage.alt">
        }
      </ng-template>
      <ng-template #mobileVideoTmp>
        @if ((block.backgroundVideoPhone || (!block.mediaImagePhone && block.backgroundVideo)); as mobileVideo) {
          <lib-video
            [src]="mobileVideo | videoPresign | async"
            class="background-video position-contain"
            [hideControls]="true"
            [loop]="true"
            [autoplay]="true">
          </lib-video>
        }
      </ng-template>
    </a>
    @if (block.text || block.link) {
      <div
        class="block-container"
        #contentWrapperEl
        [class.pointer-events-none]="block.link?.uri && (block.mediaImage || block.mediaImagePhone)">
        @if (block.text) {
          <div class="content description py-0 py-sm-2 px-sm-0 ck-text" [innerHtml]="block.text | safeHtml" [rtl]="block.langcode"></div>
        }
        @if (block.link && block.link.title) {
          <div class="content button-wrapper py-0 py-sm-2 px-sm-0" [ngClass]="'position-' + (block.buttonPosition || 'left')">
            @if (!block.link.isExternal) {
              <button mat-flat-button class="button button--primary button--large" [routerLink]="[block.link.uri]" [style.background-color]="block.buttonColor" [style.color]="block.buttonTextColor">
                <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
              </button>
            }
            @if (block.link.isExternal) {
              <a mat-flat-button class="button button--primary button--large" [href]="block.link.uri" target="_blank" [style.background-color]="block.buttonColor" [style.color]="block.buttonTextColor">
                <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
              </a>
            }
            <ng-template #buttonContent>
              <span class="button-text">{{block.link.title}}</span>
              <mat-icon iconPositionEnd>navigate_next</mat-icon>
            </ng-template>
          </div>
        }
      </div>
    }
  </section>
}
